import stls from '@f_qwep/styles/component/price/Price.module.sass';

export function CellAdminCode({ info }: any) {
    return <p className={stls.cellStatus}>{info.row.original.adminCode}</p>;
}
